import React from "react";
import Navbar from "./navbar";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <Outlet /> {/* This renders the matched route's component */}
      </main>
    </>
  );
};

export default Layout;